import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { AuthProvider } from './context/AuthContext';
import { TournamentProvider } from './context/TournamentContext';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { MatchDetailPage } from './pages/MatchDetailPage';
import { GameScorecardPage } from './pages/GameScorecardPage';
import { ResultsPage } from './pages/ResultsPage';
import { PlayerStatsPage } from './pages/PlayerStatsPage';
import { PlayerDetailPage } from './pages/PlayerDetailPage';
import { LoginPage } from './pages/LoginPage';
import { MyMatchesPage } from './pages/MyMatchesPage';
import { AdminPage } from './pages/AdminPage';
import { ProfilePage } from './pages/ProfilePage';
import './index.css';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <TournamentProvider>
          <Routes>
            {/* Public pages with layout */}
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/match/:id" element={<MatchDetailPage />} />
              <Route path="/game/:id" element={<GameScorecardPage />} />
              <Route path="/results" element={<ResultsPage />} />
              <Route path="/stats" element={<PlayerStatsPage />} />
              <Route path="/stats/:playerId" element={<PlayerDetailPage />} />
              <Route path="/my-matches" element={<MyMatchesPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/profile" element={<ProfilePage />} />
            </Route>
            {/* Login without layout */}
            <Route path="/login" element={<LoginPage />} />
          </Routes>
        </TournamentProvider>
      </AuthProvider>
      <Analytics />
    </BrowserRouter>
  );
}
